export default class Logger {
    public static Log(data: any) {
        console.log(data);
    }

    public static Error(data: any) {
        console.log('ERROR: ' + data);
    }
}
